module.exports = __webpack_public_path__ + "img/member.db41c418.svg";